module.exports = __webpack_public_path__ + "img/carouselImg-2.c394773e.jpg";